import { memo, useEffect, useState } from 'react';
import apiClient from '../../utils/apiclient';

const Index = () => {
const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiClient.get('/bulk-orders');
                setData(response.data);
            } catch (error) {
                console.error('Error fetching bulk orders:', error);
            }
        };

        fetchData();
    }, []);

    const handleCall  = async (id) => {
            const response = await apiClient.put(`/bulk-orders/${id}/called`);

            if(response.status===200){
                setData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, called: true }
          : item
      )
    );
            }

    }
    const handleDone  = async (id) => {
            const response = await apiClient.put(`/bulk-orders/${id}/done`);
            if(response.status===200){
                setData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, done: true }
          : item
      )
    );
            }
        }
  return (
   <div className="w-full flex-1 flex flex-col min-h-0 mt-4">
      <div className="flex justify-between items-center mb-2 flex-shrink-0">
        <h2 className="text-xl font-bold text-gray-800">Bulk Orders</h2>
      </div>

      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Customer</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Phone</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Delivery</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">People</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Food</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Budget</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Additional Requirements</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Status</th>
              {(isAdmin) && (
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">
                Actions
              </th>)}
            </tr>
          </thead>

          <tbody>
            {data.map((item) => (
              <tr
                key={item.id}
                className="border border-gray-300 hover:bg-gray-50"
              >
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm">
                  <div>
                    <p className="font-semibold text-gray-800">
                      {item.name}
                    </p>
                    <p className="text-gray-500">
                      {item.deliveryLocation} 
                    </p>
                  </div>
                </td>

                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                  {item.phoneNumber}        
                </td>

                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm">
                  <div>
                    <p className="text-gray-800">{item.deliveryDate}</p>
                    <p className="text-gray-500">
                      {item.deliverySlot}
                    </p>
                  </div>
                </td>

                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                  {item.peopleRange}
                </td>

                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm">
                  <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-full">
                    {item.foodTypes}
                  </span>
                </td>

                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                  {item.budgetRange}
                </td>
                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                  {item.additionalRequirements}
                </td>

                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm">
                  <span className="bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full font-semibold">
                    {item.done&&item.called?"Completed":item.called?"Called":"Pending"}
                  </span>
                </td>

                <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm">
                  {(isAdmin) && (
                  <div className="flex gap-2 justify-center">
                    <button className="bg-blue-500 hover:bg-blue-600 transition px-2 py-0.5 md:px-3 md:py-1 rounded text-white font-medium" onClick={()=>handleCall(item.id)}>
                      {item.called?"Called":"Call"}
                    </button>
                    <button className="bg-green-500 hover:bg-green-600 transition px-2 py-0.5 md:px-3 md:py-1 rounded text-white font-medium" onClick={()=>handleDone(item.id)}>
                      {item.done?"Done":"Mark Done"}
                    </button>
                  </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default memo(Index);